import { render, staticRenderFns } from "./MPreRegisterResend.vue?vue&type=template&id=cd5947c0&scoped=true&"
import script from "./MPreRegisterResend.vue?vue&type=script&lang=ts&"
export * from "./MPreRegisterResend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5947c0",
  null
  
)

export default component.exports